import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Result, Button } from 'antd';

export function ReportSuccess() {
  useEffect(() => {
    document.title = "Fakejobs - Laporan berhasil"
  }, []);
  return (
    <div>
      <Result
        status="success"
        title="Laporan kamu sudah terkirim!"
        subTitle="Laporan akan segera divalidasi. Terima kasih sudah membantu."
        extra={[
          <Link to="/">
            <Button type="primary" key="console">
              Kembali Ke Halaman Utama
            </Button>
          </Link>,
          <Link to="/report">
            <Button key="buy">Laporkan Lagi</Button>
          </Link>,
        ]}
      />,
    </div>
  );
}

export function ReportFailed() {
  useEffect(() => {
    document.title = "Fakejobs - Laporan gagal"
  }, []);
  return (
    <div className="container-fluid">
       <Result
        status="error"
        title="Submission Failed"
        subTitle="Please check and modify the following information before resubmitting."
        extra={[
          <Link to="/report">
            <Button type="primary">
              Coba Lagi
            </Button>
          </Link>,
          <Link to="/">
            <Button >Kembali Ke Halaman Utama</Button>
          </Link>,
        ]}
      />
    </div>
  );
}

export default { ReportSuccess, ReportFailed};